import { WhatsAppIcon } from "../common/WhatsAppIcon";
import { WA_DEFAULT } from "../../data/site";

export const WhatsAppFloat = () => (
  <a
    href={WA_DEFAULT}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float"
    aria-label="WhatsApp'tan Daha Fazla Bilgi Al"
    className="group fixed bottom-5 right-[88px] z-40 flex h-14 items-center overflow-hidden rounded-full bg-ink-900 px-4 text-cream-50 shadow-xl transition-transform duration-300 hover:scale-[1.03] active:scale-95 sm:bottom-6 sm:right-[92px]"
  >
    <WhatsAppIcon size={24} className="shrink-0" />
    <span className="max-w-0 overflow-hidden whitespace-nowrap text-[12px] font-semibold uppercase tracking-[0.12em] opacity-0 transition-all duration-300 ease-out group-hover:ml-2.5 group-hover:max-w-[190px] group-hover:opacity-100">
      Daha Fazla Bilgi Al
    </span>
  </a>
);
